import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

import * as ActionsStyles from '@components/shared/Actions/styles'

export const Toolbar = styled(Box)`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
`

export const AddFilterButton = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 2px 8px;
    border: none;
    background: none;
    font-size: 12px;
    font-weight: 600;
    color: ${theme.colors.primary};
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  `}
`

export const ExtraField = styled(Box)`
  position: relative;
`

export const RemoveFieldButton = styled.button`
  ${({ theme }) => css`
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
    display: flex;
    padding: 2px;
    border: none;
    background: none;
    color: ${theme.colors.gray[400]};
    cursor: pointer;

    &:hover {
      color: ${theme.colors.error.color};
    }
  `}
`

// Mesmo visual do menu "Ações" das tabelas (Actions); só muda o posicionamento, que lá é fixo
export const MenuPaper = styled(ActionsStyles.MenuPaper)`
  margin: 4px 0 0 !important;
  min-width: 220px;
`

export const MenuList = ActionsStyles.MenuList
export const CloseIconBox = ActionsStyles.CloseIconBox
export const CloseIcon = ActionsStyles.CloseIcon
export const MenuItemBox = ActionsStyles.MenuItemBox

export const MenuItem = styled(ActionsStyles.MenuItem)`
  justify-content: space-between;
`

export const MenuItemLabel = styled(Box)`
  ${({ theme }) => css`
    color: ${theme.colors.secondary};
  `}
`
